/** Must match `validate_organisation_logo_upload` in `api/apps/organisations/logo_media.py`. */
export const ORGANISATION_LOGO_MAX_BYTES = 2 * 1024 * 1024

export const ORGANISATION_LOGO_MAX_PX = 400

export const ORGANISATION_LOGO_ACCEPT: Record<string, string[]> = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
}

export const ORGANISATION_LOGO_HELPER_TEXT =
  "Square PNG or JPEG, max 400×400 px, up to 2 MB. Uploads apply immediately."

export const ORGANISATION_LOGO_TYPE_ERROR = "File type not accepted. Use PNG or JPEG."

/** Client-side dimension check before multipart upload. */
export function validateOrganisationLogoFile(file: File): Promise<string | null> {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      const { naturalWidth: width, naturalHeight: height } = img
      if (width !== height) {
        resolve("Logo must be square (1:1 aspect ratio).")
        return
      }
      if (width > ORGANISATION_LOGO_MAX_PX || height > ORGANISATION_LOGO_MAX_PX) {
        resolve(`Logo must be at most ${ORGANISATION_LOGO_MAX_PX}×${ORGANISATION_LOGO_MAX_PX} pixels.`)
        return
      }
      resolve(null)
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      resolve("Could not read image. Use a valid PNG or JPEG file.")
    }
    img.src = url
  })
}
